module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_path.js
// module id = 653
// module chunks = 48 49 50 51